<template>
  <span class="badge badge-primary d-inline-flex align-items-center">
    <span class="badge badge-light text-dark">{{ entity.type }}</span>
    <span class="ml-0-5">{{ entity.name }}</span>
  </span>
</template>

<script>
export default {
  props: {
    entity: { type: Object, required: true },
  },
};
</script>
